import type {FC} from 'react';
import Bell01Icon from '@untitled-ui/icons-react/build/esm/Bell01';
import {Badge, IconButton, SvgIcon, Tooltip} from '@mui/material';
import {usePopover} from 'src/hooks/use-popover';
import {PWMNotificationsPopover} from './PWMNotificationsPopover'

import {useNotifications} from '../../hooks/use-notifications';

export const PWMNotificationsButton: FC = () => {
  const popover = usePopover<HTMLButtonElement>();
  const notifications = useNotifications();

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton
          ref={popover.anchorRef}
          onClick={popover.handleOpen}
        >
          <Badge
            color="error"
            badgeContent={notifications?.count}
          >
            <SvgIcon>
              <Bell01Icon/>
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      <PWMNotificationsPopover
        anchorEl={popover.anchorRef.current}
        notifications={notifications?.notifications || []}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
